import "/src/css/app.css";

/* Alpine JS */
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'

Alpine.plugin(intersect)
Alpine.plugin(collapse)

window.Alpine = Alpine

Alpine.start()


// Lazysizes
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';


// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  });
}